export { default as withLoadable } from 'react-loadable'

export * from './load-module'



// WEBPACK FOOTER //
// ./src/modules/module-loader/index.ts